import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import React from 'react';
import { DragHandle, ListItem, SortableElementContainer } from './components';
import { DragHandlePosition } from './types';

export const SortableItem = ({
  item,
  id,
  disabled,
  style,
  dragHandlePosition,
}): JSX.Element => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled });

  const containerStyle = {
    ...style,
    transform: CSS.Transform.toString(transform),
    transition: transition || undefined,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <SortableElementContainer
      ref={setNodeRef}
      style={containerStyle}
      {...attributes}
    >
      <ListItem>
        {(dragHandlePosition as DragHandlePosition) === 'left' && !disabled ? (
          <DragHandle title={item.title} {...listeners} />
        ) : null}
        {item.listItem}
        {(dragHandlePosition as DragHandlePosition) === 'right' && !disabled ? (
          <DragHandle title={item.title} {...listeners} />
        ) : null}
      </ListItem>
    </SortableElementContainer>
  );
};
